import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const InfoLegaliPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="pt-32 pb-16 bg-gradient-to-br from-blue-600 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Informazioni Legali</h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
            Informazioni societarie, privacy policy e termini e condizioni
          </p>
        </div>
      </section>
      
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gray-50 rounded-2xl p-10 mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Informazioni Societarie</h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p><strong>Ragione Sociale:</strong> Amaca S.r.l.</p>
              <p><strong>Sede Legale:</strong> Via Don Domenico D'Angelo 31, 80025 Casandrino (NA), Italia</p>
              <p><strong>Partita IVA:</strong> 10914011217</p>
              <p><strong>Email:</strong> ordini.amacasrl@gmail.com</p>
              <p><strong>PEC:</strong> amacasrl2025@pec.it</p>
              <p><strong>Telefono:</strong> +39 350 862 8049</p>
            </div>
          </div>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Privacy Policy</h2>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. Titolare del Trattamento</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              Il Titolare del trattamento dei dati personali è Amaca S.r.l., con sede legale in Via Don Domenico D'Angelo 31, 80025 Casandrino (NA), P.IVA 10914011217. Per qualsiasi informazione relativa al trattamento dei dati personali, è possibile contattare il Titolare all'indirizzo email ordini.amacasrl@gmail.com o tramite PEC amacasrl2025@pec.it.
            </p>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Tipologia di Dati Raccolti</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              I dati personali raccolti attraverso il sito web includono:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6">
              <li>Dati identificativi: nome, cognome, ragione sociale</li>
              <li>Dati di contatto: indirizzo email, numero di telefono</li>
              <li>Dati aziendali: nome azienda, partita IVA</li>
              <li>Dati di navigazione: indirizzo IP, tipo di browser, pagine visitate</li>
            </ul>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Finalità del Trattamento</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              I dati personali sono trattati per le seguenti finalità:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6">
              <li>Gestione delle richieste di informazioni e preventivi</li>
              <li>Evasione degli ordini e gestione dei rapporti commerciali</li>
              <li>Invio di comunicazioni commerciali e promozionali (previo consenso)</li>
              <li>Adempimento degli obblighi contabili e fiscali</li>
              <li>Miglioramento dei servizi offerti</li>
            </ul>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Base Giuridica del Trattamento</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              Il trattamento dei dati personali si basa sul consenso dell'interessato, sull'esecuzione di un contratto o di misure precontrattuali, sull'adempimento di obblighi legali e sul legittimo interesse del Titolare.
            </p>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Modalità di Trattamento</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              I dati personali sono trattati con strumenti informatici e telematici, con logiche strettamente correlate alle finalità indicate e con l'adozione di misure di sicurezza adeguate per prevenire la perdita, l'uso illecito o non corretto e gli accessi non autorizzati.
            </p>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">6. Comunicazione e Diffusione dei Dati</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              I dati personali possono essere comunicati a soggetti terzi quali fornitori di servizi informatici, consulenti, corrieri e spedizionieri, esclusivamente per le finalità sopra indicate. I dati non saranno diffusi.
            </p>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">7. Diritti dell'Interessato</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              L'interessato ha il diritto di:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6">
              <li>Accedere ai propri dati personali</li>
              <li>Richiedere la rettifica o la cancellazione degli stessi</li>
              <li>Richiedere la limitazione del trattamento</li>
              <li>Opporsi al trattamento</li>
              <li>Richiedere la portabilità dei dati</li>
              <li>Revocare il consenso in qualsiasi momento</li>
              <li>Proporre reclamo all'Autorità Garante per la Protezione dei Dati Personali</li>
            </ul>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">8. Periodo di Conservazione</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              I dati personali saranno conservati per il tempo necessario al perseguimento delle finalità per cui sono stati raccolti e in conformità agli obblighi di legge.
            </p>
            
            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Termini e Condizioni</h2>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. Oggetto</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              I presenti termini e condizioni regolano l'utilizzo del sito web di Amaca S.r.l. e i rapporti commerciali tra la società e i propri clienti.
            </p>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Servizi Offerti</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              Amaca S.r.l. opera nel settore del commercio all'ingrosso di computer, cellulari e software, fornendo prodotti tecnologici a rivenditori, system integrator e aziende. I prezzi e le condizioni commerciali sono riservati ai clienti B2B registrati.
            </p>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Ordini e Pagamenti</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              Gli ordini possono essere effettuati tramite email, telefono o attraverso il sito web. I pagamenti sono regolati secondo le condizioni concordate con ciascun cliente. Amaca S.r.l. si riserva il diritto di rifiutare ordini in caso di mancato pagamento di fatture precedenti.
            </p>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Consegne</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              Le consegne vengono effettuate in tutta Italia tramite corrieri convenzionati. I tempi di consegna indicativi sono di 24-48 ore lavorative dalla conferma dell'ordine. Amaca S.r.l. non è responsabile per ritardi imputabili al corriere.
            </p>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Garanzia</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              Tutti i prodotti sono coperti dalla garanzia ufficiale del produttore. In caso di difetti di conformità, il cliente può richiedere la riparazione o la sostituzione del prodotto secondo quanto previsto dalla normativa vigente.
            </p>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">6. Resi</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              I resi sono accettati entro 14 giorni dalla consegna per prodotti non conformi o difettosi. Il cliente deve comunicare tempestivamente il problema e restituire il prodotto nelle condizioni originali. I costi di spedizione per il reso sono a carico del cliente, salvo in caso di prodotto difettoso.
            </p>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">7. Limitazione di Responsabilità</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              Amaca S.r.l. non è responsabile per danni indiretti, perdite di profitto o danni consequenziali derivanti dall'utilizzo dei prodotti venduti. La responsabilità è limitata al valore del prodotto acquistato.
            </p>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">8. Proprietà Intellettuale</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              Tutti i contenuti del sito web, inclusi testi, immagini, loghi e grafica, sono di proprietà di Amaca S.r.l. o dei rispettivi proprietari e sono protetti dalle leggi sul diritto d'autore.
            </p>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">9. Legge Applicabile e Foro Competente</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              I presenti termini e condizioni sono regolati dalla legge italiana. Per qualsiasi controversia è competente il Foro di Napoli.
            </p>
            
            <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">10. Modifiche</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              Amaca S.r.l. si riserva il diritto di modificare i presenti termini e condizioni in qualsiasi momento. Le modifiche saranno pubblicate sul sito web e entreranno in vigore dalla data di pubblicazione.
            </p>
            
            <div className="bg-blue-50 border-l-4 border-blue-600 p-6 mt-12">
              <p className="text-gray-700 leading-relaxed">
                <strong>Ultimo aggiornamento:</strong> Gennaio 2025
              </p>
              <p className="text-gray-700 leading-relaxed mt-2">
                Per qualsiasi domanda o chiarimento riguardo alle presenti informazioni legali, è possibile contattare Amaca S.r.l. all'indirizzo email ordini.amacasrl@gmail.com o al numero di telefono +39 350 862 8049.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default InfoLegaliPage;
